import { groupBy } from 'ramda';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';
import { STEPS } from '../constants';
import { STEPS_FOUR_STAGES } from '../constants_four_stages';
import PcModelOptionsGroup from '../PcModelOptionsGroup';
import PcModelOptionsReview from '../PcModelOptionsReview';
import styles from './styles';

const PcModelOptions = ( {modelTheme }) => {
  const { options, subGroups, pcModel, errors } = usePcConfigurator();

  const optionsFourStages = ['build', 'ultra-labs', 'accessories (new)'];
  let isInArray = false;
  let currentStep;

  if (options?.length != 0) {
    isInArray = optionsFourStages.includes(options[0].group_step_new);
    if (isInArray) {
      [currentStep] = useQueryParam(
        'step',
        withDefault(StringParam, STEPS_FOUR_STAGES[0]),
      );
    } else {
      [currentStep] = useQueryParam(
        'step',
        withDefault(StringParam, STEPS[0]),
      );
    }
  }

  let filteredOptions;

  if (isInArray) {
    filteredOptions = options.filter(
      (option) => { 
        if (currentStep == 'ultralabs') {
          return option.group_step_new === 'ultra-labs'
        } else if (currentStep== 'accessoriesnew') {
          return option.group_step_new === 'accessories (new)'
        } else {
          return option.group_step_new === currentStep
        }
      }
    );
  } else {
    filteredOptions = options.filter(
      (option) => option.group_step_new === currentStep,
    );
  }

  const groupByGroupType = groupBy((item) => item.group_type);
  const optionsByGroupType = groupByGroupType(filteredOptions);
  const groupTypes = Object.keys(optionsByGroupType);

  if (currentStep === 'review') {
    return <PcModelOptionsReview />;
  }

  return (
    <>
      <div className="pc_model_accordion">
        {groupTypes.map((groupType, k) => (
          <PcModelOptionsGroup 
            key={`${groupType}_${k}`}
            pcModel={pcModel}
            errors={errors}
            allSubGroups={subGroups} 
            groupType={groupType}
            options={options}
            modelTheme={modelTheme}
             />
        ))}
        {/* <PcModelStepsNext /> */}
      </div>

      <style jsx>{styles}</style>
    </>
  );
};

export default PcModelOptions;
